export default "\n{% block sw_cms_block_text_hero %}\n<div class=\"sw-cms-block-text-hero\">\n    <slot name=\"content\"></slot>\n</div>\n{% endblock %}\n";